import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/**
 * Fichier stocké par le file-service-bundle (GET /stonecode_file_files), ex. l'image d'une signature. Lisible par ceux
 * qui lisent son objet (sa « source ») ; se retrouve par l'URN de celle-ci (filtre typeSource.source.entityUrn).
 * Privé : son contenu ne se lit que par une adresse temporaire (downloadUrl), pas en <img src> direct (JWT en header).
 */
export default class FileModel extends AbstractApiModel {
  protected _path = '/stonecode_file_files/{?id}';

  declare _tsFilters: { 'typeSource.source.entityUrn'?: string | string[] };

  @doc.string declare name: string;

  /**
   * Adresse de téléchargement signée (S3), valable 5 minutes : GET …/download_url => { url }. forceDownload : le
   * stockage renvoie le fichier en pièce jointe (enregistré, pas affiché : un export CSV) ; sinon en ligne (une image)
   */
  async downloadUrl(forceDownload = false): Promise<string> {
    const query = forceDownload ? '?force-download=1' : '';
    const { data } = await this.connector.fetch(`${this.fullPath}/download_url${query}`, { silentError: true });

    return (data as { url: string }).url;
  }
}
